import React from 'react';
import { Button, Typography } from '@mui/material';
import StandardDialog, { StandardDialogActions } from '../../../Modals/StandardDialog';

type RejectAssessmentDialogProps = {
  isOpen: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  disabled?: boolean;
};

const RejectAssessmentDialog = ({ isOpen, handleClose, onConfirm, disabled }: RejectAssessmentDialogProps) => (
  <StandardDialog
    title={'Reject Assessment?'}
    handleClose={handleClose}
    isOpen={isOpen}
  >
    <Typography>Are you sure you want to reject this assessment?</Typography>
    <StandardDialogActions>
      <Button variant='outlined' onClick={handleClose}>Cancel</Button>
      <Button
        variant='contained'
        color='error'
        onClick={onConfirm}
        disabled={disabled}
      >
        Reject
      </Button>
    </StandardDialogActions>
  </StandardDialog>
);

export default RejectAssessmentDialog;
